import React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import styles from './index.less';
import Store from './store';

/**
 * fifthPage
 * @param store {fifthPageStore}
 * @returns {JSX.Element}
 * @constructor
 */
const FifPage = ({ store, isActive, mechaId, kvImg }) => {
  store.use();
  const { mechaInfo } = store;

  return (
    <div className={cx(styles.mecha, isActive && styles.active)} style={{ backgroundImage: `url(${kvImg})` }}>
      <Link data-mecha-id={mechaId} className={styles.btnDetailTriggerArea} />
      <div className={cx(styles.btnDetail)} style={{ backgroundImage: `url(${mechaInfo.btnDetail})` }} />
      <div className={styles.role} style={{ backgroundImage: `url(${mechaInfo.role})` }} />
    </div>
  );
};

export default wrapStore(FifPage, Store);
